import { useState, useEffect } from 'react';
import './About.css';
import { getAllReviews, getAvgRating } from '../utils/reviewsStore';

export default function About() {
  const [avg, setAvg] = useState('4.9');

  useEffect(() => {
    setAvg(getAvgRating(getAllReviews()));
  }, []);
  return (
    <section className="about-section" id="about">
      <div className="container about-inner">
        <div className="about-left">
          <div className="about-founder-card">
            <div className="founder-avatar">AR</div>
            <div>
              <div className="founder-name">Aryan</div>
              <div className="founder-title">Founder, LathiNyx DevLabs™</div>
            </div>
          </div>
          <div className="about-stats-col">
            {[['10+','Clients Served'],['10+','Projects Done'],['8+','Months Exp'],[avg+'★','Rating']].map(([v,l]) => (
              <div key={l} className="about-stat">
                <div className="about-stat-val">{v}</div>
                <div className="about-stat-label">{l}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="about-right">
          <span className="section-tag">About LathiNyx DevLabs™</span>
          <h2 className="about-heading">We Are More Than a Digital Agency — We Are Your Growth Partner</h2>
          <p className="about-para">
            Hello, I'm <strong>Aryan</strong> — a freelance developer and digital solutions specialist dedicated to making professional-grade digital services accessible to businesses, startups, researchers, and individuals of all sizes and budgets.
          </p>
          <p className="about-para">
            I provide comprehensive digital solutions at the intersection of web development, artificial intelligence, and academic research. In the past few months alone, I've collaborated with over 10 clients, successfully delivering projects ranging from dynamic websites and AI-powered systems to specialized research paper services.
          </p>
          <p className="about-para">
            What sets me apart is my commitment to partnership. I don't just fulfill project briefs — I take the time to understand each client's unique goals, business context, and challenges. My approach is consultative and collaborative, ensuring every solution is thoughtfully tailored, whether it's a simple landing page or a sophisticated AI-driven platform.
          </p>
          <p className="about-para">
            My tagline, <strong>"Building Intelligent Digital Systems"</strong>, encapsulates my philosophy. I engineer complete digital solutions that seamlessly blend elegant design, robust technology, and smart automation — empowering clients to achieve faster, smarter growth.
          </p>
          <div className="about-skills">
            {['React.js','Node.js','WordPress','Python','OpenAI API','LangChain','Research Writing','Data Analysis','SEO'].map(s => (
              <span key={s} className="about-skill-tag">{s}</span>
            ))}
          </div>
          <a href="/#contact" className="btn-primary" style={{ marginTop: 24, display: 'inline-flex' }}>Work With Aryan →</a>
        </div>
      </div>
    </section>
  );
}
